/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_TitleInputs */

const en_home_title = /** @type {(inputs: Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ollio — book your apartment`)
};

/**
* | output |
* | --- |
* | "ollio — book your apartment" |
*
* @param {Home_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_title = /** @type {((inputs?: Home_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_title(inputs)
});